import { PROBING_FORM_EXP } from './constants';
import { ShopeeEntryPoint } from '@/config/constants';
import coreStore from '@/stores/core';

export const getProbingFormExperiment = () => {
  const from = coreStore.safeGetStore('initStore').from;

  // 只给除了 shopee food hc 之外的在 shopee 的入口使用
  if (
    [ShopeeEntryPoint.shopeeFoodHC].includes(ShopeeEntryPoint[from as keyof typeof ShopeeEntryPoint])
    || (from && ShopeeEntryPoint[from] === undefined)
  ) {
    return PROBING_FORM_EXP.None;
  }

  const fromLowerCase = from?.toLocaleLowerCase?.();
  const userStore = coreStore.safeGetStore('userStore');
  const newABTestConfig = userStore.newABTestingConfigs;
  const isPremiumEntryPoint = fromLowerCase?.includes?.('premium');

  //  premium 入口与其他入口使用不同的实验配置
  return (isPremiumEntryPoint ? newABTestConfig.probing_form_premium : newABTestConfig.probing_form_all) || PROBING_FORM_EXP.None;
};
